// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__kxxu3","left":"InfoRow_left__2tx7s"};